/* Scroll position for the horizontal video rails.
   The rails scroll but gave no indication how much was left, so on a phone the
   fourth clip was easy to miss entirely. The bar tracks the rail directly
   rather than animating on a timer, so it cannot drift out of sync. */
(() => {
  if (window.cloudRailProgressBound) return;
  window.cloudRailProgressBound = true;

  const sync = (bar) => {
    const rail = bar.previousElementSibling;
    const fill = bar.firstElementChild;
    if (!rail || !fill) return;
    const scrollable = rail.scrollWidth - rail.clientWidth;
    if (scrollable <= 1) {
      bar.hidden = true;
      return;
    }
    bar.hidden = false;
    const ratio = Math.min(1, Math.max(0, rail.scrollLeft / scrollable));
    const visible = rail.clientWidth / rail.scrollWidth;
    fill.style.width = `${Math.max(12, visible * 100)}%`;
    fill.style.transform = `translateX(${(ratio * (100 / Math.max(visible, 0.12) - 100))}%)`;
  };

  const start = () => {
    document.querySelectorAll('[data-cloud-rail-progress]').forEach((bar) => {
      const rail = bar.previousElementSibling;
      if (!rail) return;
      sync(bar);
      rail.addEventListener('scroll', () => sync(bar), { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(() => sync(bar)).observe(rail);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
